mutation DisconnectCCBill {
  disconnectCCBill {
    id
    paymentSettings {
      provider
      ccbill {
        accnum
        subaccount
        flexFormId
        saltMask
        webhookUrl
        supportUrl
        sandbox
        connectedAt
      }
    }
  }
}
